import { render, staticRenderFns } from "./VueperSlide.vue?vue&type=template&id=7b65ce56"
import script from "./VueperSlide.vue?vue&type=script&lang=ts"
export * from "./VueperSlide.vue?vue&type=script&lang=ts"
import style0 from "./VueperSlide.vue?vue&type=style&index=0&id=7b65ce56&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports